// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fixedwidth[data-v-1ee725ce] {\r\n  max-width: 700px;\n}\r\n", ""]);
// Exports
module.exports = exports;
